(function ($) {
	$(document).ready(function () {
    const heroslider =  $('#hero-vertical-slideshow').slick({
         
            infinite: true,
            arrows: false,
            dots: true,
            speed: 900,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1
          });
 $(heroslider).on('beforeChange', function(event, slick, currentSlide, nextSlide){
         $('.section-hero-slideshow').removeClass('slide' + (currentSlide + 1) + '-current').addClass('slide' + (nextSlide + 1) + '-current');
});
    
      
         
$('#story-swiper').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
        
      }
    }

  ]
});
      
$('.hero-slider-main-warp').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 1600
  
});      
      

      
$(".fb-stickeybar").mouseover(function() {
    $(this).css("right","0");
}).mouseout(function() {
    $(this).css("right","-305px");
});      
      
      

$(".faq-box h5").click(function () {
  //$('.c-faq-warp ul li').removeClass('is-active');
 // $('.c-faq-warp ul li .faq-box .faq-ans').hide();
  $(this).parent().toggleClass('is-active');
  $(this).next().slideToggle();
   });
	
   $('#testmonials-id').flickity({
    // options
    cellAlign: 'right',
    freeScroll: true, 
    contain: true,
    pageDots: false
  });
  
  $(window).scroll(function(){
    if ($(this).scrollTop() > 10) {
       $('#theme-header').addClass('is-scroll');
    } else {
       $('#theme-header').removeClass('is-scroll');
    }
});

$( ".main-nav > ul" ).clone().appendTo( "#swipe-menu .mob-nav").removeAttr('id').addClass('swip-nav-ul');
$( ".top-nav > ul" ).clone().appendTo( "#swipe-menu .mob-nav").removeAttr('id').addClass('swip-nav-ul');
 
$('#swipe-menu .site-nav--dropdown').removeAttr('id');
      
 $('#swipe-menu ul.swip-nav-ul ul').slideUp(); 

         $('#swipe-menu ul.swip-nav-ul li').has('ul').addClass('has-submenu').append( '<span class="sub-toggle"></span>' );

         $('#swipe-menu ul.swip-nav-ul li span.sub-toggle').on('click', function () {
                $(this).siblings('li').find('ul').slideDown();
                $('#swipe-menu ul.swip-nav-ul ul', this).slideToggle();
            });
        
          $('.sub-toggle').on('click',function(){
                $(this).toggleClass('expanded');
                $(this).parent('li').find('> ul').slideToggle();
                $(this).parent('li').siblings('li').find('> .sub-toggle').removeClass('expanded');
                $(this).parent('li').siblings('li').find('> ul').slideUp();
            });       
      

$(".ham-btn").click(function () {

  $('#swipe-menu').toggleClass('is-active');
});
$(".swipe-close").click(function () {

  $('#swipe-menu').removeClass('is-active');
});
      
      
 //filter isotop

var $casegrid = $('#video-grid').isotope({
  itemSelector: '.grid-item',
  percentPosition: true,
  masonry: {
    // use outer width of grid-sizer for columnWidth
    columnWidth: '.grid-sizer'
   
  }
  });


// filter items on button click
$('.filter-button-group').on( 'click', 'button', function() {
var filterValue = $(this).attr('data-filter');
$casegrid.isotope({ filter: filterValue });
});

// change is-checked class on buttons
$('.button-group').each( function( i, buttonGroup ) {
var $buttonGroup = $( buttonGroup );
$buttonGroup.on( 'click', 'button', function() {
  $buttonGroup.find('.is-checked').removeClass('is-checked');
  $( this ).addClass('is-checked');
});
});
 
  if($('.section-product-feature').length){    
var stickyTop = ( $(".section-product-feature").offset().top - 250);
     

$(window).on( 'scroll', function(){
        if ($(window).scrollTop() >= stickyTop) {
            $('.product-feature-dot').addClass('is-active');
        } else {
            $('.product-feature-dot').removeClass('is-active');
        }
    });   
  }
     
         
});    
})(jQuery)